module.exports = __webpack_public_path__ + "fonts/euclid-square-600.cac8a39e.ttf";